import { render } from "./CellsField.vue?vue&type=template&id=17402e3d&scoped=true"
import script from "./CellsField.vue?vue&type=script&lang=js"
export * from "./CellsField.vue?vue&type=script&lang=js"

import "./CellsField.vue?vue&type=style&index=0&id=17402e3d&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17402e3d"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QField});
